import { ApiResponse, CalculateRecommendedSolutionProductResponse } from "../Models";

export const calculateRecommendedSolutionProductMockup: ApiResponse<CalculateRecommendedSolutionProductResponse> = {
    statusCode: 200,
    error: null,
    data: {
        currentDayReleaseRemainValues: [],
        mostRecommendedFormula: "Multicote Agri 4M 24-04-24 (28-0-32%)",
        yield: [
            {
                value: 55,
                mesurmentUnitCode: "1",
                mesurmentUnit: "",
            },
            {
                value: 0.02453495,
                mesurmentUnitCode: "2",
                mesurmentUnit: "",
            },
        ],
        soilId: 1,
        waterId: 1,
        cropCode: "63",
        startingDate: "2021-07-22T00:00:00",
        finishDate: "2021-11-19T00:00:00",
        countryCode: "IL",
        materialCode: "3006005",
        releaseGraphValues: [
            {
                index: 0,
                month: 1,
                nutrient: [
                    {
                        name: "N",
                        releaseValues: [
                            { value: 50, mesurmentUnitCode: "1", mesurmentUnit: "Kg/Ha" },
                            { value: 53, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
                        ],
                    },
                    {
                        name: "P",
                        releaseValues: [
                            { value: 50, mesurmentUnitCode: "1", mesurmentUnit: "Kg/Ha" },
                            { value: 53, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
                        ],
                    },
                    {
                        name: "K",
                        releaseValues: [
                            { value: 50, mesurmentUnitCode: "1", mesurmentUnit: "Kg/Ha" },
                            { value: 53, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
                        ],
                    },
                ],
            },
        ],
    },
};
